import { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressSpinner } from "primereact/progressspinner";
import CopyBarcodeSerial from "../controls/CopyBarcodeSerial";
import {
  formatCurrency,
  formatDate,
  formatQuantity,
} from "../../shared/utility";

function placeName(value) {
  if (value == null || String(value).trim() === "") {
    return "—";
  }
  return value;
}

export default function InventoryManufacturedSubTable(props) {
  const {
    groups,
    loading,
    cartonsByKey,
    loadingCartons,
    cartonKeyFor,
    onExpandGroup,
    unitOfMeasure,
  } = props;

  const [expandedGroups, setExpandedGroups] = useState(null);

  if (loading) {
    return <ProgressSpinner style={{ width: "30px", height: "30px" }} />;
  }

  const cartonExpansion = (group) => {
    const key = cartonKeyFor(group);
    if (loadingCartons[key]) {
      return <ProgressSpinner style={{ width: "30px", height: "30px" }} />;
    }

    const cartons = cartonsByKey[key] ?? [];

    return (
      <div className="operational-embedded-table overflow-hidden rounded-lg border border-[#E2E8F0] bg-white">
        <DataTable
          value={cartons}
          className="p-datatable-sm text-sm"
          dataKey="id"
          emptyMessage="No cartons in this location and zone."
        >
          <Column
            header="Barcode serial"
            body={(row) => (
              <CopyBarcodeSerial
                barcode={row.shipping_barcode || row.serial_number}
              />
            )}
            style={{ minWidth: "10rem" }}
          />
          <Column
            field="lot_number"
            header="Lot"
            style={{ minWidth: "8rem" }}
          />
          <Column
            header="Packaging date"
            body={(row) => formatDate(row.packaging_date)}
            style={{ minWidth: "9rem" }}
          />
          <Column
            header="Case weight"
            alignHeader="right"
            body={(row) =>
              formatQuantity(
                row.packing_size,
                row.unit_of_measure || unitOfMeasure,
              )
            }
            style={{ minWidth: "8rem", textAlign: "right" }}
            bodyClassName="text-right tabular-nums"
          />
        </DataTable>
      </div>
    );
  };

  return (
    <div className="operational-embedded-table overflow-hidden rounded-lg border border-[#E2E8F0] bg-white">
      <DataTable
        value={groups ?? []}
        expandedRows={expandedGroups}
        onRowToggle={(event) => setExpandedGroups(event.data)}
        onRowExpand={(event) => onExpandGroup(event.data)}
        rowExpansionTemplate={cartonExpansion}
        dataKey="group_key"
        className="p-datatable-sm text-sm"
        emptyMessage="No stock in the selected location or zone."
      >
        <Column
          header="Location"
          body={(row) => placeName(row.location_name)}
          style={{ minWidth: "10rem" }}
        />
        <Column
          header="Zone"
          body={(row) => placeName(row.zone_name)}
          style={{ minWidth: "8rem" }}
        />
        <Column
          header="Quantity in stock by weight"
          alignHeader="right"
          body={(row) =>
            formatQuantity(
              row.stock_in_weight,
              row.unit_of_measure || unitOfMeasure,
            )
          }
          style={{ minWidth: "12rem", textAlign: "right" }}
          bodyClassName="text-right tabular-nums"
        />
        <Column
          header="Quantity in stock/case"
          alignHeader="right"
          field="total_individual_units"
          style={{ minWidth: "10rem", textAlign: "right" }}
          bodyClassName="text-right tabular-nums"
        />
        <Column
          header="Total Dollar Amount"
          alignHeader="right"
          body={(row) => (
            <span className="tabular-nums font-medium text-[#0F172A]">
              {formatCurrency(row.total_dollar_amount)}
            </span>
          )}
          style={{ minWidth: "9rem", textAlign: "right" }}
          bodyClassName="text-right tabular-nums"
        />
        <Column expander={() => true} header="" style={{ width: "5rem" }} />
      </DataTable>
    </div>
  );
}
